import { render } from "./WUltimasSolicitudesRequerimientos.vue?vue&type=template&id=577bbe43&scoped=true"
import script from "./WUltimasSolicitudesRequerimientos.vue?vue&type=script&lang=js"
export * from "./WUltimasSolicitudesRequerimientos.vue?vue&type=script&lang=js"

import "./WUltimasSolicitudesRequerimientos.vue?vue&type=style&index=0&id=577bbe43&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-577bbe43"]])

export default __exports__